import { OPEN_GRAPH_IMAGE_PATH } from "../seo/social-card";

/** Canonical public identity used by every metadata and structured-data projection. */
export const SITE_URL = "https://ishvaram.com";
export const SITE_NAME = "Ishvaram";
export const SITE_LOGO = `${SITE_URL}/images/brand/ishvaram-wordmark.png`;

/**
 * The Organization logo for structured data: the square 512x512 brand mark
 * (public/icon-512.png). Google wants a square logo of at least 112px; the
 * wide SITE_LOGO wordmark above stays for the header.
 */
export const ORGANIZATION_LOGO = {
  "@type": "ImageObject",
  url: `${SITE_URL}/icon-512.png`,
  width: 512,
  height: 512,
} as const;

// Merchant-listing Product.image uses the same generated social card as page
// metadata, so rich-result and share-image URLs cannot drift independently.
export const PRODUCT_IMAGE = `${SITE_URL}${OPEN_GRAPH_IMAGE_PATH}`;

// Google merchant listings require the product brand's name, not only an @id
// reference to an Organization node elsewhere in the graph.
export const BRAND = { "@type": "Brand", name: SITE_NAME } as const;

export function mobileApplicationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    "@id": `${SITE_URL}#app`,
    name: SITE_NAME,
    alternateName: "Ishvaram AI Vedic Astrology",
    operatingSystem: "ANDROID, IOS",
    applicationCategory: "LifestyleApplication",
    publisher: { "@id": `${SITE_URL}#org` },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
    },
    downloadUrl: [
      "https://play.google.com/store/apps/details?id=com.ishvaram.app",
      "https://apps.apple.com/app/id6743459479",
    ],
  };
}
